<template>
  <div class="breadcrumbs">
    <div class="container">
      <ul class="breadcrumbs_list">
        <li v-for="item in breaditems" :key="item.to">
          <template v-if="!item.disable">
            <nuxt-link :to="$formatUrl(localePath(item.to))" class="breadcrumb_link">
              {{ item.alt ? item.alt : item.text }}
            </nuxt-link>
          </template>
          <template v-else>
            {{ item.alt ? item.alt : item.text }}
          </template>
        </li>
      </ul>
      <button class="breadcrumbs_mob orange_link" @click.prevent="goBack()">
        <i class="arrow_right" />
        <span>
          {{ $t('breadcrumbs.back') }}
        </span>
      </button>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    breaditems: {
      type: Array,
      default: null
    }
  },
  jsonld () {
    const items = this.breaditems.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': process.env.API_URL_BROWSER + this.localePath(item.to),
        name: item.alt ?? item.text
      }
    }))
    return {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items
    }
  },
  methods: {
    goBack () {
      window.history.back()
    }
  }
}
</script>
